import React from 'react';
import { Link } from 'react-router-dom';
import { WorkoutCard, WorkoutImage, WorkoutBody, TinyAvatar, OuterMargin, EmptyWorkoutImage } from './style';
import { Text } from '../../UI/Text';
import { Column, Row } from '../../Layouts';
import { getWorkoutType, generateSlugLink } from '../../../Utils';
import { Icon } from '../../Components/Icons/Icons';

export const Card = ({ hasLink, id, smallImage, title, description, workoutType, user }) => {
    const workoutLink = `${generateSlugLink({ name: user.fullName, id: user.id })}/workout/${id}`;
    return (
        <WorkoutCard>
            <ConditionalLinkWrapper hasLink={hasLink} path={workoutLink}>
                <WorkoutImage background={smallImage} />
            </ConditionalLinkWrapper>

            <WorkoutBody>
                <Column justify={'space-between'}>
                    <ConditionalLinkWrapper hasLink={hasLink} path={workoutLink}>
                        <Text fontSize={16} opacity={0.9} weight={'bold'}>
                            {title}
                        </Text>
                    </ConditionalLinkWrapper>

                    <Row align={'center'}>
                        <OuterMargin right={'8px'}>
                            <TinyAvatar image={user.smallImage} />
                        </OuterMargin>
                        <OuterMargin right={'8px'}>
                            <Text weight={200} fontSize={11} opacity={0.75}>
                                {user.fullName}
                            </Text>
                        </OuterMargin>
                        <OuterMargin right={'8px'}>
                            <Text weight={200} fontSize={11} opacity={0.75}>
                                &#8226;
                            </Text>
                        </OuterMargin>
                        <Text weight={200} fontSize={11} opacity={0.75}>
                            {getWorkoutType(workoutType)}
                        </Text>
                    </Row>
                    <Text weight={200} fontSize={12} opacity={0.5}>
                        {description ? description : 'No description provided...'}
                    </Text>
                </Column>
            </WorkoutBody>
        </WorkoutCard>
    );
};

const ConditionalLinkWrapper = ({ hasLink, path, children }) =>
    hasLink ? <Link to={path}>{children}</Link> : <div>{children}</div>;

export const EmptyWorkoutCard = () => (
    <WorkoutCard>
        <EmptyWorkoutImage>
            <Icon.Box opacity={0.71} size={'24x24'}>
                <Icon.Edit />
            </Icon.Box>
        </EmptyWorkoutImage>
        <WorkoutBody>
            <Column justify={'center'}>
                <Text fontSize={16} opacity={0.9} weight={'bold'}>
                    Plan new workout
                </Text>
            </Column>
        </WorkoutBody>
    </WorkoutCard>
);

// // TODO: refactor in  workout reducer
// Card.defaultProps = {
//     image: {
//         data: {},
//     },
//     user: {
//         data: {
//             image: {
//                 data: {},
//             },
//         },
//     },
// };



// WEBPACK FOOTER //
// ./src/UI/Containers/PlannedWorkouts/WorkoutCard.js